module.exports = __webpack_public_path__ + "static/media/blue-corner-graphic.cc0cfee1.png";